module.exports = __webpack_public_path__ + "img/inner_img.9a6a7305.png";